import React from 'react';
import { reduxConnect } from '../../common';
import { FooterWrapper } from './footerWrapper';
import type { IStoreState } from '../common/interfaces/types';

const disabledFooterPopups = [
    'video',
    'story',
    'photo'
];

type FooterProps = {
    popupId: string;
    pageFooterSetup: string;
}

const isFooterDisabled = ( popupId: string, pageFooterSetup: string ) =>
{
    let enablePageFooter = true;
    if (disabledFooterPopups.includes(popupId?.toLowerCase())) {
        enablePageFooter = false;
    }

    if (pageFooterSetup?.toLowerCase() === 'none') {
        enablePageFooter = false;
    }

    return enablePageFooter;
};

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { popupId, pageFooterSetup } = storeState?.appState?.appState || {};

    return {
        popupId,
        pageFooterSetup
    };
};

const mapDispatchToProps = {};
export const Footer = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ pageFooterSetup, popupId }: FooterProps) =>
{
    const isEnabled = isFooterDisabled(popupId, pageFooterSetup);
    if (!isEnabled) {
        return null;
    }

    return (
        <FooterWrapper />
    );
});

Footer.DisplayName = 'Footer';
